import { FC, useMemo } from 'react';
import classNames from 'classnames';

import styles from 'src/styles/common/templateGallery.module.scss';
import { StateFormReturnType } from 'src/utils/stateForm';
import { UiCleanDropdown } from 'src/components/UI/dropdown/CleanDropdown';
import { useNsTHelper } from 'src/utils/i18n';
import { useStateFormValueWatch } from 'src/utils/stateForm/useFormWatch/useStateFormValueWatch';
import { FormValues } from 'src/components/Modals/TemplateGallery/screens/All/index';
import { TemplateGalleryAvailableCategoriesListItemType } from 'src/models/Modals/templateGallery';

type Props = {
  isMobile: boolean;
  formProps: StateFormReturnType<FormValues>;
  categories: TemplateGalleryAvailableCategoriesListItemType[];
};

export const TemplateGalleryCategories: FC<Props> = ({ isMobile, formProps, categories }) => {
  const tHelper = useNsTHelper('modals.templateGallery', 'all');

  const activeCategory = useStateFormValueWatch(formProps.getSubscribeProps, 'category');

  const items = useMemo(() => categories.map((item) => ({ value: item.ID, label: item.Title })), [categories]);

  return (
    <div className={styles.categories}>
      <div className={styles.subhead}>{tHelper('categories')}</div>
      {isMobile ? (
        <UiCleanDropdown
          material
          formProps={formProps}
          name="category"
          items={items}
          className={styles.dropdown}
          optionClassName={styles.dropdownOption}
        />
      ) : (
        <div className={styles.categoriesWrapper}>
          {items.map((item) => (
            <div
              role="presentation"
              key={item.value}
              onClick={() => formProps.setValue('category', item.value)}
              className={classNames(styles.category, activeCategory === item.value && styles.active)}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
